export const ADD_PRODUCT_CATEGORIES_SUCCESS = 'ADD_PRODUCT_CATEGORIES_SUCCESS';
export const LIST_ALL_CATEGORIES_SUCCESS = 'LIST_ALL_CATEGORIES_REQUEST_SUCCESS';
export const UPDATE_PRODUCT_CATEGORIES_SUCCESS = 'UPDATE_PRODUCT_CATEGORIES_SUCCESS';
export const LIST_ALL_CATEGORIES_REQUEST = 'LIST_ALL_CATEGORIES_REQUEST';
export const LIST_ALL_CATEGORIES_FAILURE = 'LIST_ALL_CATEGORIES_FAILURE';
export const DELETE_PRODUCT_CATEGORY_SUCCESS = 'DELETE_PRODUCT_CATEGORY_SUCCESS';
export const CREATE_PRODUCT_CATEGORIES_SUCCESS = 'CREATE_PRODUCT_CATEGORIES_SUCCESS';
